import React, { } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { cn } from 'src/lib/utils'
import ContentCircle from 'src/Common/ui/contentCircle'
import '../../../Styles/Tasktable.css'
import * as RiskTypes from '../../../Entities/RiskTypes'
import dayjs from 'dayjs'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import { FaRegCircle } from 'react-icons/fa6'

export default function ViewTasktable ({ data, formData, departments, errors, control, monitoringEdit, setFormData }) {
    const handleEditAction = (value, index) => {
        const taskCompletedMarkedData = data?.filter((filData, _) => filData?.actions !== 11)?.map((mapDt, mapIdx) => {
            if (mapIdx === index) {
                return { ...mapDt, actions: value ? RiskTypes.TASK_COMPLETED_STATUS : null }
            } else {
                return mapDt
            }
        })

        const checkedCount = taskCompletedMarkedData?.filter(item => item.actions === RiskTypes.TASK_COMPLETED_STATUS).length

        setFormData({ ...formData, taskLists: taskCompletedMarkedData, taskListScoring: (checkedCount / taskCompletedMarkedData?.length) * 100 })
    }

    const CustomCheckbox = ({ checked, onClick }) => {
        return (
            <div onClick={onClick} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', fontSize: '24px' }}>
                {checked
                    ? (
                        <AiOutlineCheckCircle color="green" />
                    )
                    : (
                        <FaRegCircle color="gray" />
                    )}
            </div>
        )
    }

    return (
        <>
            <div className='h-[100%]'>
                <div className='h-[90%]'>
                    <div>
                        <TableContainer className={cn('task-table')} style={{ maxHeight: 500 }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow className='!bg-none'>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '17px' }} align='center'>{'S.No'}</TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Task'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Start Date'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'End Date'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Department'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Responsible'}
                                            </p>
                                        </TableCell>
                                        {monitoringEdit &&
                                            <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                                <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                    {'Action'}
                                                </p>
                                            </TableCell>
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.map((item, j) => {
                                        item.sNo = j + 1
                                        return (item?.actions !== 11 &&
                                            <>
                                                <TableRow sx={{ height: '30px' }}>
                                                    <TableCell align='center' >
                                                        <div className='w-full flex justify-center'>
                                                            <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary'} content={item.sNo} />
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ height: '100%' }} >
                                                        <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                            {<div style={{ whiteSpace: 'wrap' }} className='h-full'>{item?.name}</div>
                                                            }
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ height: '100%' }} >
                                                        <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                            {<div style={{ whiteSpace: 'wrap' }} className='h-full'>{dayjs(item?.startDate).format('DD/MM/YYYY')}</div>
                                                            }
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ height: '100%' }} >
                                                        <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                            {<div style={{ whiteSpace: 'wrap' }} className='h-full'>{dayjs(item?.endDate).format('DD/MM/YYYY')}</div>
                                                            }
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ height: '100%' }} >
                                                        <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                            {<div style={{ whiteSpace: 'wrap' }} className='h-full'>{departments?.find(ele => ele.id === item?.departmentId)?.name}</div>
                                                            }
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ height: '100%' }} >
                                                        <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                            {<div style={{ whiteSpace: 'wrap' }} className='h-full'>{item?.responsible}</div>
                                                            }
                                                        </p>
                                                    </TableCell>
                                                    {/* {!viewCondition() && <TableCell align='center' sx={{ color: 'hsl(var(--primary))' }}>
                                                    <p className={cn('task-table-td')}>{t('yes')}</p>
                                                </TableCell>} */}
                                                    {monitoringEdit &&
                                                     <TableCell align='center' >
                                                         {/* <Radio
                                                             type='checkbox'
                                                             key={`${item.name}-${j}`}
                                                             name="status"
                                                             sx={{ color: 'hsl(var(--primary))' }}
                                                             //  valueSelected={item.status === RiskTypes.TASK_COMPLETED_STATUS ? 'on' : 'off'}
                                                             checked={item.status === RiskTypes.TASK_COMPLETED_STATUS}
                                                             onClick={(el) => handleEditAction(el, j)}
                                                         /> */}
                                                         <CustomCheckbox
                                                             key={`${item.name}-${j}`}
                                                             checked={item.actions === RiskTypes.TASK_COMPLETED_STATUS}
                                                             onClick={() => handleEditAction(item.actions !== RiskTypes.TASK_COMPLETED_STATUS, j)}
                                                         />
                                                     </TableCell>}
                                                    {/* <TableCell align='center' sx={{ whiteSpace: 'nowrap' }}>{item?.answer === '1' || item?.answer === '2' ? <div className={'text-[hsl(var(--Low))] font-semibold mt-2'}>{item?.answer === '1' ? 'Applicable' : 'Not applicable'}</div> : null}</TableCell> */}
                                                </TableRow>
                                            </>

                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                {/* {!viewCondition() && <div className='w-full flex justify-end mt-5 pr-1 cursor-pointer'>
                        <div className='flex gap-2 items-center text-primary' onClick={() => { handleAddControls('binaryQuestions') } }><AddSquareIcon /> <span>New</span></div>
                    </div>} */}
                {/* {data.length > 0 && <div className="flex items-center justify-between mt-2 p-4 h-[10%]">
                        <Typography className="text-muted">
                                Showing data {currentPage} to {rowsPerPage} of {totalPages} entries
                        </Typography>
                        <Pagination
                            sx={{ marginLeft: 'auto' }}
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded" />
                    </div>} */}
            </div>
        </>
    )
}
